module.exports = __webpack_public_path__ + "img/pipette.9041cbff.png";